import React, { useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import ContactCTA from "./ContactCTA";

// Shared shell for every subpage: nav, content, an optional closing CTA band, footer.
const PageLayout = ({ title, children, hideContactCta = false, testId }) => {
    useEffect(() => {
        if (title) document.title = title;
    }, [title]);

    return (
        <>
            <Nav />
            <main className="relative" data-testid={testId}>
                {children}
                {!hideContactCta && <ContactCTA />}
            </main>
            <Footer />
        </>
    );
};

export default PageLayout;
